<template>
    <div>
		<div class="d-flex align-items-center justify-content-between mg-b-25">
			<h3 class="df-title">Documents</h3>
			<div class="d-flex">
				<a href="#newDocument" data-toggle="modal" class="btn btn-sm btn-outline-default shadow-sm">
					<i data-feather="file-plus" class="wd-10 mg-r-5"></i> New Document
				</a>
			</div>
		</div>

		<div class="row">
            <div class="col-12">
                <alert-success :form="form" :class="'d-block shadow-sm'" message="Document was created successfully!"></alert-success>
                <alert-success :form="editForm" :class="'d-block shadow-sm'" message="Document was updated successfully!"></alert-success>
				<alert-success :form="deleteForm" :class="'d-block shadow-sm'" message="Document was deleted successfully!"></alert-success>
            </div>

			<div class="col-12 mg-t-20 mg-sm-t-25">
                <table id="documents-table" class="table">
                    <thead>
                        <tr>
                            <th class="wd-10p"></th>
                            <th class="wd-15p">Date</th>
                            <th class="wd-30p">Name</th>
                            <th class="wd-0p">Url</th>
                            <th class="wd-10p">Type</th>
							<th class="wd-25p">Client</th>
                            <th class="wd-10p"></th>
                        </tr>
                    </thead>
                </table>
            </div>
		</div>

		<div class="modal" id="newDocument" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<form class="modal-content" enctype="multipart/form-data" @submit.prevent="newDocument">
                    <div class="modal-header">
                        <button type="button" class="close pos-absolute t-15 r-20" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						<h5 class="modal-title">New Document</h5>
                    </div>
					<div class="modal-body">
						<div class="form-group">
							<label>Name</label>
							<input v-model="form.name" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': editForm.errors.has('name') }" name="name" placeholder="Enter document name" required>
							<has-error :form="form" field="name"></has-error>
						</div>
						<div class="form-group">
							<label>Type</label>
							<select v-model="form.type" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('type') }" required>
                                <option :value="null" disabled>Select document type</option>
                                <option v-for="(type, index) in documentTypes" :value="type.toLowerCase()" :key="index">{{ type }}</option>
                            </select>
							<has-error :form="form" field="type"></has-error>
						</div>
                        <div class="form-group">
							<label>Client</label>
							<select v-model="form.external_client_id" id="client" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('external_client_id') }">
								<option :value="null" disabled>Select Client</option>
							</select>
							<has-error :form="form" field="external_client_id"></has-error>
						</div>
						<div class="form-group">
							<label>File</label>
							<div class="custom-file shadow-sm">
								<input type="file" class="form-control custom-file-input" name="file" :class="{ 'is-invalid': form.errors.has('file') }" id="new" @change="selectFile" required>
								<label class="custom-file-label" for="file" aria-describedby="file">Choose file</label>
							</div>
							<has-error :form="form" field="file"></has-error>
						</div>
					</div>
					<div class="modal-footer">
						<div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
							<button-component :busy="form.busy" :label="'Add Document'" :label-loading="'Please wait...'" :button-class="'btn btn-default shadow-sm mg-b-5 mg-sm-b-0'"></button-component>
							<button type="button" class="btn btn-primary shadow-sm mg-sm-l-5" data-dismiss="modal">Cancel</button>
						</div>
					</div>
				</form>
			</div>
		</div>

        <div class="modal" id="editDocument" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<form class="modal-content" enctype="multipart/form-data" @submit.prevent="editDocument">
                    <div class="modal-header">
                        <button type="button" class="close pos-absolute t-15 r-20" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						<h5 class="modal-title">Edit Document</h5>
                    </div>
					<div class="modal-body">
						<div class="form-group">
							<label>Name</label>
							<input v-model="editForm.name" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': editForm.errors.has('name') }" name="name" placeholder="Enter document name" required>
							<has-error :form="editForm" field="name"></has-error>
						</div>
						<div class="form-group">
							<label>Type</label>
							<select v-model="editForm.type" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('type') }" required>
                                <option :value="null" disabled>Select document type</option>
                                <option v-for="(type, index) in documentTypes" :value="type.toLowerCase()" :key="index">{{ type }}</option>
                            </select>
							<has-error :form="editForm" field="type"></has-error>
						</div>
                        <div class="form-group">
							<label>Client</label>
							<select v-model="editForm.external_client_id" id="editClient" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('external_client_id') }">
								<option :value="null" disabled>Select Client</option>
							</select>
							<has-error :form="editForm" field="external_client_id"></has-error>
						</div>
						<div class="form-group">
							<label class="wd-100p">
								File
								<span class="float-right"><a class="" id="file-url" target="popup">View current file</a></span>
							</label>
							<div class="custom-file shadow-sm">
								<input type="file" class="form-control custom-file-input" :class="{ 'is-invalid': form.errors.has('file') }" name="file" id="update" @change="selectFile">
								<label class="custom-file-label" for="file" aria-describedby="file">Choose file</label>
							</div>
							<has-error :form="editForm" field="file"></has-error>
						</div>
					</div>
					<div class="modal-footer">
						<div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
							<button-component :busy="editForm.busy" :label="'Update Document'" :label-loading="'Please wait...'" :button-class="'btn btn-default shadow-sm mg-b-5 mg-sm-b-0'"></button-component>
							<button type="button" class="btn btn-primary shadow-sm mg-sm-l-5" data-dismiss="modal">Cancel</button>
						</div>
					</div>
				</form>
			</div>
		</div>
        
        <div class="modal" id="deleteDocument" tabindex="-1" role="dialog" aria-labelledby="deleteDocumentModal" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                <form class="modal-content" @submit.prevent="deleteDocument">
                    <div class="modal-header">
                        <h5 class="modal-title" id="deleteDocumentModal">Delete Document</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="mg-b-0">Are you sure you want to delete this Document?</p>
                    </div>
                    <div class="modal-footer">
						<div class="wd-100p d-flex flex-column flex-sm-row">
							<button type="submit" class="btn btn-danger shadow-sm mg-b-5 mg-sm-b-0 col-6">Yes, Delete</button>
							<button type="button" class="btn btn-primary shadow-sm mg-sm-l-5 col-6" data-dismiss="modal">No, Cancel</button>
						</div>
					</div>
                </form>
            </div>
        </div> 
    </div>
</template>

<script>
	const objectToFormData = require("../../../../js/scripts/objectToFormData");

	export default {
		mounted() {
			this.loadOptions().then(() => {
				$("#client").select2({
					data: this.clients,
					placeholder: "Select client",
					dropdownParent: $("#newDocument"),
					width: "100%"
				});

				$("#editClient").select2({
					data: this.clients,
					placeholder: "Select client",
					dropdownParent: $("#editDocument"),
					width: "100%"
				});
			});

			$("#client").on("select2:select", e => {
				const client = _.find(this.clients, ["id", e.params.data.id]);

				this.form.external_client_id = client.id;
			});
			$("#client").on("select2:unselect", e => {
				this.form.external_client_id = null;
			});

			$("#editClient").on("select2:select", e => {
				const client = _.find(this.clients, ["id", e.params.data.id]);

				this.editForm.external_client_id = client.id;
			});
			$("#editClient").on("select2:unselect", e => {
				this.editForm.external_client_id = null;
			});

			this.table = $("#documents-table").DataTable({
				processing: true,
				serverSide: true,
				ajax: {
					headers: {
						Authorization: `Bearer ${localStorage.token}`
					},
					url: "/api/documents?datatable=true",
					dataFilter: data => {
						var json = JSON.parse(data);

						return JSON.stringify(json.data);
					}
				},
				responsive: true,
				deferRender: true,
				columnDefs: [
					{
						targets: 0,
						visible: false
					},
					{
						targets: 3,
						visible: false,
						render: function(data, type, row, meta) {
							return `<a href="${data}" target="popup" onclick="window.open('${data}','popup','width=600,height=800'); return false;" class="tx-black">View Document</a>`;
						}
					},
					{
						targets: 4,
						className: "text-center tx-bold",
						render: function(data, type, row, meta) {
							return _.startCase(data);
						}
					},
					{
						targets: [4, -1],
						className: "text-center"
					},
					{
						targets: 5,
						render: function(data, type, row, meta) {
							return row[5]
								? `<a href="/app/clients/${row[5]}" class="tx-black">${row[6]}</a>`
								: '<span class="text-muted">N/A</span>';
						}
					},
					{
						targets: -1,
						orderable: false,
						data: "id",
						render: function(data, type, row, meta) {
							return (
								`<div class="dropdown dropleft">` +
								`<button class="btn btn-sm btn-white shadow-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">` +
								`Options` +
								`</button>` +
								`<div class="dropdown-menu shadow-sm">` +
								`<h6 class="dropdown-header tx-uppercase tx-12 tx-bold tx-inverse">Options</h6>` +
								`<a class="dropdown-item" href="#editDocument" data-toggle="modal" data-action="edit" data-row="${meta.row}"><i data-feather="edit-2" class="wd-15 mg-r-5"></i> Edit</a>` +
								`<a class="dropdown-item tx-danger" href="#deleteDocument" data-toggle="modal" data-action="delete" data-row="${meta.row}"><i data-feather="trash-2" class="wd-15 mg-r-5"></i> Delete</a>` +
								`<div class="dropdown-divider"></div>` +
								`<a class="dropdown-item" href="${row[3]}" target="popup" onclick="window.open('${row[3]}','popup','width=600,height=800'); return false;"><i data-feather="eye" class="wd-15 mg-r-5"></i> View</a>` +
								`</div>` +
								`</div>`
							);
						}
					}
				],
				language: {
					searchPlaceholder: "Search...",
					sSearch: "",
					lengthMenu: "_MENU_",
					emptyTable: "No documents uploaded."
				},
				initComplete: (settings, json) => {
					feather.replace();
				},
				drawCallback: settings => {
					feather.replace();
				}
			});

			$("#documents-table tbody").on("click", "a[data-toggle='modal']", e => {
				const data = this.table.row(e.target.dataset.row).data();

				if (e.target.dataset.action === "edit") {
					$("#file-url").attr("href", data[3]);
					$("#file-url").attr(
						"onclick",
						`window.open('${data[3]}','popup','width=600,height=800')`
					);
					$("#editClient")
						.val(data[5])
						.trigger("change");

					this.editForm.fill({
						_method: "PATCH",
						id: data[0],
						name: data[2],
						type: data[4].toLowerCase(),
						external_client_id: data[5] || ""
					});
				}

				if (e.target.dataset.action === "delete") {
					this.deleteForm.fill({
						id: data[0]
					});
				}
			});

			$("#newDocument, #editDocument, #deleteDocument").on(
				"hidden.bs.modal",
				e => {
					$("#client, #editClient")
						.val(null)
						.trigger("change");
					$(".custom-file-label").html("Choose file");

					this.form.reset();
					this.editForm.reset();
				}
			);
		},
		data() {
			return {
				table: null,
				clients: null,
				documentTypes: this.$store.getters.document_types,
				form: new Form({
					id: null,
					name: null,
					type: null,
					external_client_id: null,
					file: null
				}),
				editForm: new Form({
					_method: null,
					id: null,
					name: null,
					type: null,
					external_client_id: null,
					file: null
				}),
				deleteForm: new Form({
					id: null
				})
			};
		},
		methods: {
			getClients() {
				return axios.get("/api/clients");
			},
			loadOptions() {
				return axios.all([this.getClients()]).then(
					axios.spread(clients => {
						let clientsCollection = _.map(
							clients.data.data.clients,
							data => {
								const f = data.first_name;
								const m = data.additional_names || " ";
								const l = data.last_name;

								const client_name = f + " " + m + " " + l;

								return {
									id: data.external_client_id,
									text: client_name,
									external_custody_account_id:
										data.external_custody_account_id
								};
							}
						);

						this.clients = _.sortBy(clientsCollection, ["text"]);
					})
				);
			},
			selectFile(e) {
				const file = e.target.files[0];
				const type = e.target.id;

				if (type === "new") {
					this.form.file = file;
				}

				if (type === "update") {
					this.editForm.file = file;
				}
			},
			newDocument() {
				this.form
					.submit("post", "/api/documents", {
						transformRequest: [
							function(data, headers) {
								return objectToFormData(data);
							}
						]
					})
					.then(({ data }) => {
						this.table.ajax.reload();
						$("#newDocument").modal("hide");
					});
			},
			editDocument() {
				this.editForm
					.submit("post", `/api/documents/${this.editForm.id}`, {
						transformRequest: [
							function(data, headers) {
								return objectToFormData(data);
							}
						]
					})
					.then(({ data }) => {
						this.table.ajax.reload();
						$("#editDocument").modal("hide");
					});
			},
			deleteDocument() {
				this.deleteForm
					.delete(`/api/documents/${this.deleteForm.id}`)
					.then(({ data }) => {
						this.table.ajax.reload();
						$("#deleteDocument").modal("hide");
					});
			}
		}
	};
</script>
